<template>
    <div class="container-fluid order-details">
        <div class="row justify-content-lg-center">
<!--            <ul class="d-flex breadcrumb-list mb-5">-->
<!--                <li class="breadcrumb-item"><a href="/" class="text-decoration-none">{{ breadCrumbs.home }} </a></li>-->
<!--                <li class="breadcrumb-item active"><a href="/user/orders" class="text-decoration-none">{{ breadCrumbs.order }} </a></li>-->
<!--                <li class="breadcrumb-item active">{{ breadCrumbs.orderDetail }}</li>-->
<!--            </ul>-->
            <TheLoaderComponent v-if="showLoader"></TheLoaderComponent>

            <div class="d-flex flex-column col-lg-2 preview__block">
<!--            <div class="d-flex flex-column col-lg-2 preview__block" :class="{'d-none': orderStatus !== 'Delivered'}">-->
                <div class="preview__header">
                    <h3>How did we do?</h3>
                    <p>
                        Salam from Sketchat!
                    </p>
                    <p class="mt-md-4">
                        Thanks for shopping with us at Sketchat. We would like to get your feedback on the overall
                        recent experience with Sketchat. Our survey will only take a few minutes.
                    </p>
                </div>

                <form class="d-flex flex-column mt-md-3">
                    <div class="mt-md-3 form-group question__block" v-for="(question,name,index) in reviewQuestion">
                        <h4 class="form-label">{{ name }}</h4>
                        <p>{{ question }}</p>

                        <div class="d-flex justify-content-between mt-4" v-if="index != 5">
                            <i class="fa-regular fa-thumbs-down"></i>

                            <div class="radio" v-for="number in 5">
                                <label class="custom-radio">
                                    <input type="radio" @change="validation(name)"
                                           v-model="dataReview[name]" :name="name" :value="number">
                                    <span class="d-flex flex-column">{{ number }}</span>
                                </label>
                            </div>

                            <i class="fa-regular fa-thumbs-up"></i>
                        </div>

                        <textarea v-if="index === 5" @input="validation(name)"
                                  v-model="dataReview[name]" name="comment"
                                  class="clear-error mt-4 js-email-question mb-0"></textarea>

                        <span class="error-text js-question__error d-none" :class="`js-error_input-${name}`"
                              role="alert" style="color: red">
                        <strong>The {{ name }} field is required.</strong>
                    </span>
                    </div>
                    <button type="button"
                            class="btn btn-purple mt-5 d-flex h-auto w-100  ms-auto justify-content-center"
                            @click=sendComment()>
                        Sent
                    </button>
                </form>

            </div>
            <div class="d-flex col-lg-10"
                 :class="{'col-12 delivered-model__block full-width ps-0': orderStatus !== 'Shipping','delivered-model__block': orderStatus === 'Shipping'}">
                <div class="w-100">
                    <CardModelComponent :order="'order'" :orderStatus="orderStatus"
                                        :products="this.orders"/>
                </div>

            </div>

            <div class="h-100" v-if="orderStatus === 'New'">
                <button class="btn btn-purple h-auto w-auto mt-4" @click="payOrder">Pay order</button>
            </div>

            <div class="h-100" v-if="orderStatus === 'Declined'">
                <button class="btn btn-purple w-auto h-auto mt-4" @click="updateOrder">Update order</button>
            </div>
        </div>
    </div>
</template>

<script type="application/javascript">
import TheLoaderComponent from "./TheLoaderComponent";
import CardModelComponent from "./CardModelComponent";

export default {
    components: {
        TheLoaderComponent,
        CardModelComponent,

    },
    data() {
        return {
            showLoader: false,
            orders: null,
            lang: window.currentlang,
            orderStatus: localStorage.getItem('orderStatus'),
            comment: null,
            reviewQuestion: [],
            dataReview: {
                Checkout: null,
                Expectation: null,
                Satisfaction: null,
                Shipment: null,
                Recommend: null,
            },
            breadCrumbs: {
                home: '',
                order: '',
                orderDetail: '',
            }
        }
    },

    mounted() {
        this.orders = orders.items

        this.orders.forEach(item => {
            if (item.file_hash !== null) {
                item.dynamic_img = '/storage/models_dynamic_mp4/' + item.model.file_hash + '_' + item.model.file_size + '_' + item.model.color.replace('#', '') + '.mp4';
                item.img = '/storage/models_static_gif/' + item.model.file_hash + '_' + item.model.file_size + '_' + item.model.color.replace('#', '') + '.gif';
                item.dynamic_img_ready = false;
                item.mouseover = false;
                item.hover = false;
            }
        })

        this.getReviewQuestion()


        let liLang = document.querySelectorAll('.js-change-lang li')
        this.changeContent()
    },

    methods: {
        changeContent() {
            if (window.currentLang === 'ar-sa') {
                this.breadCrumbs.home = 'الرئيسية'
                this.breadCrumbs.order = 'طلب'
                this.breadCrumbs.orderDetail = 'تفاصيل الطلب'
            } else {
                this.breadCrumbs.home = 'Home'
                this.breadCrumbs.order = 'Order'
                this.breadCrumbs.orderDetail = 'Order detail'
            }
        },

        payOrder() {
            axios.get(`/order/${orderId}/pay`).then(function (response) {
                 location.href = response.request.responseURL
            })
        },
        validation(name) {
            if (this.dataReview[name]) {
                let error = document.querySelector(`.js-error_input-${name}`)
                error && error.classList.add('d-none')
            }
        },
        getReviewQuestion() {
            let vm = this
            axios.get('/review/question').then(function (response) {
                vm.reviewQuestion = response.data.review_question
            })
        },

        sendComment() {
            let data = {
                comment: JSON.stringify(this.dataReview)
            }

            for (let key in this.dataReview) {
                if (this.dataReview.hasOwnProperty(key)) {
                    if (!this.dataReview[key]) {
                        let error = document.querySelector(`.js-error_input-${key}`)
                        error && error.classList.remove('d-none')

                    }
                }
            }

            function checkProperties(obj) {
                for (let key in obj) {
                    if (obj[key] == null)
                        return false;
                }
                return true;
            }

            if (checkProperties(this.dataReview)) {
                axios.post('/' + orderId + '/review', data).then(function (response) {
                    if (localStorage.getItem('lang') === 'ar-sa') {
                        response
                            ? window.notify('شكرا لك على ملاحظاتك!')
                            : window.notify('الرجاء المحاولة مرة أخرى.')
                    } else {
                        response
                            ? window.notify('Thank you for your feedback!')
                            : window.notify('Oops! Try to send your feedback again.')
                    }


                    setTimeout(() => {
                        location.href = '/user/order/' + orderId
                    })
                })
            }

        },

        updateOrder() {
            let dataToAjax = []
            let items = document.querySelectorAll('.card-model')

            items.forEach(item => {
                let id = item.querySelector('.model-id').value
                let type = item.querySelector('.quantity input[name="type"]').getAttribute('data-type')
                let objData = {}
                objData.model_id = id
                objData.count = +item.querySelector('.quantity input[name="name"]').value
                objData.type = type

                dataToAjax.push(objData)
            })

            let data = {
                order: dataToAjax,
                address_id: 1
            }

            axios.post('/order', data).then(function (response) {
                if (localStorage.getItem('lang') === 'ar-sa') {
                    window.notify('تم إنشاء الطلب')

                } else {
                    window.notify('Order created')

                }
                setTimeout(() => {
                    location.href = '/user/orders'
                })
            })
        }
    }
}
</script>

<style lang="scss">
@import "../../sass/front/order-detail";
</style>
